@if (formControl()) {
<div class="indexer form-group">
    <input id="search" [readonly]="$safeNavigationMigration(meta()?.readonly)" placeholder="search" class="input" #search [formControl]="formControl()!"
        [matAutocomplete]="auto">
    <mat-icon>search</mat-icon>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith.bind(this)" (optionSelected)="onPick($event)">
        @for (group of filtered | async; track group.key) {
        <mat-optgroup [label]="group.key">
            @for (item of group.items; track item.id) {
            <mat-option [value]="item">
                {{item.label}}
            </mat-option>
            }
        </mat-optgroup>
        }
    </mat-autocomplete>
</div>
}
